(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfUserDeleteController',ConsInfUserDeleteController);

    ConsInfUserDeleteController.$inject = ['$uibModalInstance', 'entity', 'ConsInfUser'];

    function ConsInfUserDeleteController($uibModalInstance, entity, ConsInfUser) {
        var vm = this;

        vm.consInfUser = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ConsInfUser.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
